import { observer } from '@rehaje/reactive-react'

import type { MustacheNode } from './TypedNode'
import type { ViewComponent } from '@rehaje/react'

export const MustacheComponent: ViewComponent<MustacheNode> = observer(
  ({ node }) => {
    return node.transpile(node.__r_ensureViewElement().scope, true)
  }
)
